import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/lib/axios.ts';
import type { DeployDraftListParams } from '@/shared/types/deploy.ts';

/**
 * Chaves compartilhadas entre a página da fila e o badge do menu — as duas
 * precisam invalidar o mesmo cache quando um rascunho é revisado.
 */
export const deployDraftKeys = {
  all: ['deploy-drafts'] as const,
  list: (params: DeployDraftListParams) => [...deployDraftKeys.all, 'list', params] as const,
  pendingCount: () => [...deployDraftKeys.all, 'pending-count'] as const,
};

/** Alimenta o contador no item de menu "Deploys". */
export function usePendingDeployDraftsCount() {
  return useQuery({
    queryKey: deployDraftKeys.pendingCount(),
    queryFn: async () => {
      const { data } = await api.get<{ total: number }>('/admin/deploy-drafts/pending-count');
      return data.total;
    },
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
  });
}
